module.exports = __webpack_public_path__ + "static/media/book-icon-desktop.7950481a.svg";